export default __webpack_public_path__ + "static/media/coin-ratchet-red.2614bbac.png";